import { responsiveFont } from './responsiveFont';
export function responsiveLabelFont(props) {
  return responsiveFont('label', props);
}